// src/components/Putovanja.jsx
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { supabase } from "../supabaseClient";
import "../styles/putovanja.css";

export default function Putovanja() {
  const [travels, setTravels] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadTravels();
  }, []);

  async function loadTravels() {
    try {
      // Try to load with travel_images first
      let { data, error } = await supabase
        .from("travels")
        .select("*, travel_images(*)")
        .order("id", { ascending: false });

      // If travel_images table doesn't exist, fallback to basic select
      if (error && error.message.includes("Could not find")) {
        const { data: basicData, error: basicError } = await supabase
          .from("travels")
          .select("*")
          .order("id", { ascending: false });
        
        if (basicError) throw basicError;
        data = basicData.map(t => ({ ...t, travel_images: [] }));
      }

      if (error && !error.message.includes("Could not find")) throw error;

      // Nije potreban storage fetch — već imaš public URL!
      const mapped = data.map((t) => ({
        id: t.id,
        title: t.title,
        excerpt: t.description,
        image: t.travel_images?.[0]?.image_url || t.image_url, // ← direktno iz baze
      }));

      setTravels(mapped);
    } catch (err) {
      console.error("❌ Greška kod učitavanja putovanja:", err);
    } finally {
      setLoading(false);
    }
  }

  if (loading) {
    return (
      <div className="putovanja-page">
        <h1>Učitavanje putovanja...</h1>
      </div>
    );
  }

  return (
    <div className="putovanja-page">
      <header className="putovanja-hero">
        <h1>Bezglutenska putovanja</h1>
        <p>
          Otkrijte gluten-free avanture diljem svijeta — gdje jesti, što probati
          i kako uživati bez brige u svakoj destinaciji.
        </p>
      </header>

      <section className="putovanja-grid">
        {travels.map((t) => (
          <Link key={t.id} to={`/putovanja/${t.id}`} className="putovanje-card">
            {t.image ? (
              <img src={t.image} alt={t.title} />
            ) : (
              <div className="no-image">Nema slike</div>
            )}

            <h2>{t.title}</h2>
            <p>{t.excerpt}</p>
          </Link>
        ))}
      </section>
    </div>
  );
}
